import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "src/environments/environment";

@Pipe({
    name: 'teamType',
    standalone: false
})

  export class TeamTypePipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case environment.teamTypeCostCenter:
                return 'Kostnadsställe';
            case environment.teamTypeFollowUp:
                return 'Uppföljning';
            case environment.teamTypeOnCall:
                return 'Beredskap';
            case environment.teamTypeCallList: 
                return 'Ringlista';
            case environment.teamTypeRemote: 
                return 'Remote';
            case environment.teamTypeFirstLineSupport: 
                return 'Firstline support';
            case environment.teamTypeAuth: 
                return 'Behörighet';
            default: 
                return '';
        }
    }
  
  }